<template>
  <v-container fluid class="mt-0 pt-0">
    <v-form lazy-validation ref="form" v-model="formValid">
      <v-row style="user-select:none" class="mt-0 pt-0">
        <v-col cols="12">
          <span class="menuTitle">Minha Empresa</span><br />
          <span class="menuSubtitle"
            >Atualize as informações de sua conta como cliente
            WhatsRedirect.</span
          >
        </v-col>
        <v-col cols="12" class="my-0 py-0">
          <v-radio-group dense row class="my-0 py-0" v-model="client.type">
            <v-radio value="1">
              <template v-slot:label>
                <div>
                  Pessoa Física
                </div>
              </template>
            </v-radio>
            <v-radio value="2">
              <template v-slot:label>
                <div>
                  Pessoa Jurídica
                </div>
              </template>
            </v-radio>
          </v-radio-group>
        </v-col>

        <v-col cols="8" md="4" class="my-0 py-0" v-if="client.type == 2">
          <v-text-field
            v-model="client.doc"
            v-on:blur="validateDoc()"
            type="tel"
            :rules="[
              validDoc || 'CNPJ Inválido',
              (v) => !!v || 'Este campo é obrigatório'
            ]"
            label="CNPJ"
            v-mask="['##.###.###/####-##']"
            name="cnpj"
            required
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="8" class="my-0 py-0" v-if="client.type == 2">
          <v-text-field
            v-model="client.razao"
            label="Razão Social"
            :rules="rules.required"
            name="razao_social"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4" class="my-0 py-0" v-if="client.type == 2">
          <v-text-field
            v-model="client.fantasia"
            label="Nome Fantasia"
            :rules="rules.required"
            name="nome_fantasia"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="7" md="4" class="my-0 py-0" v-else>
          <v-text-field
            v-model="client.doc"
            label="CPF"
            name="cpf"
            type="tel"
            v-mask="['###.###.###-##']"
            v-on:blur="validateDoc()"
            :rules="[
              (v) => !!v || 'Este campo é obrigatório',
              validDoc || 'O documento precisa ser válido'
            ]"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="5" class="my-0 py-0">
          <v-text-field
            v-model="client.contact"
            label="Responsável"
            name="name"
            :rules="rules.required"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3" class="my-0 py-0">
          <v-text-field
            v-model="client.phone"
            label="Telefone"
            :rules="rules.required"
            v-mask="['(##) ####-####', '(##) #####-####']"
            type="tel"
            name="phone"
            required
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="my-1 py-1">
          <span class="user-data-subtitle">Endereço:</span>
        </v-col>
        <v-col cols="5" md="2" class="my-0 py-0">
          <v-text-field
            v-model="client.address.cep"
            label="CEP"
            name="cep"
            type="tel"
            v-mask="'#####-###'"
            :rules="rules.required"
            v-on:blur="getAddress()"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="7" md="10" class="my-0 py-0"> </v-col>
        <v-col cols="8" md="6" class="my-0 py-0">
          <v-text-field
            v-model="client.address.street"
            label="Endereço"
            :rules="rules.required"
            name="address"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="4" md="2" class="my-0 py-0">
          <v-text-field
            v-model="client.address.number"
            label="Número"
            name="street_number"
            :rules="rules.required"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="6" md="4" class="my-0 py-0">
          <v-text-field
            v-model="client.address.complement"
            label="Complemento"
            name="complement"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="6" md="5" class="my-0 py-0">
          <v-text-field
            v-model="client.address.neighborhood"
            label="Bairro"
            :rules="rules.required"
            name="neighborhood"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="8" md="5" class="my-0 py-0">
          <v-text-field
            v-model="client.address.city"
            label="Cidade"
            :rules="rules.required"
            name="city"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="4" md="2" class="my-0 py-0">
          <v-text-field
            v-model="client.address.state"
            label="Estado"
            :rules="rules.required"
            v-mask="'AA'"
            name="state"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-btn
            :loading="loading"
            color="success"
            style="float:right"
            v-on:click="updateClientDetails()"
            right
          >
            Salvar
          </v-btn>
        </v-col>
      </v-row>
      <v-snackbar
        top
        right
        v-model="updateStatus.show"
        :color="updateStatus.color"
        :timeout="5000"
      >
        {{ updateStatus.message }}
      </v-snackbar>
    </v-form>
  </v-container>
</template>

<script>
// @ is an alias to /src
import { mask } from "vue-the-mask";
import Axios from "axios";

export default {
  name: "ClientProfile",
  directives: { mask },
  components: {},
  data: () => ({
    loading: false,
    formValid: true,
    client: {
      type: "2",
      doc: "",
      phone: "",
      contact: "",
      razao: "",
      fantasia: "",
      address: {
        cep: "",
        street: "",
        number: "",
        complement: "",
        neighborhood: "",
        city: "",
        state: ""
      }
    },
    rules: {
      required: [(v) => !!v || "Obrigatório"]
    },
    validDoc: true,
    updateStatus: {
      show: false,
      color: "",
      message: ""
    }
  }),
  computed: {},
  methods: {
    validCpf: function(cpf) {
      if (
        !cpf ||
        cpf.length != 11 ||
        cpf == "00000000000" ||
        cpf == "11111111111" ||
        cpf == "22222222222" ||
        cpf == "33333333333" ||
        cpf == "44444444444" ||
        cpf == "55555555555" ||
        cpf == "66666666666" ||
        cpf == "77777777777" ||
        cpf == "88888888888" ||
        cpf == "99999999999"
      )
        return false;
      let soma = 0;
      let resto;
      for (let i = 1; i <= 9; i++)
        soma = soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
      resto = (soma * 10) % 11;
      if (resto == 10 || resto == 11) resto = 0;
      if (resto != parseInt(cpf.substring(9, 10))) return false;
      soma = 0;
      for (let i = 1; i <= 10; i++)
        soma = soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);
      resto = (soma * 10) % 11;
      if (resto == 10 || resto == 11) resto = 0;
      if (resto != parseInt(cpf.substring(10, 11))) return false;
      return true;
    },
    validCnpj: function(cnpj) {
      if (
        !cnpj ||
        cnpj.length != 14 ||
        cnpj == "00000000000000" ||
        cnpj == "11111111111111" ||
        cnpj == "22222222222222" ||
        cnpj == "33333333333333" ||
        cnpj == "44444444444444" ||
        cnpj == "55555555555555" ||
        cnpj == "66666666666666" ||
        cnpj == "77777777777777" ||
        cnpj == "88888888888888" ||
        cnpj == "99999999999999"
      )
        return false;
      let tamanho = cnpj.length - 2;
      let numeros = cnpj.substring(0, tamanho);
      const digitos = cnpj.substring(tamanho);
      let soma = 0;
      let pos = tamanho - 7;
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) pos = 9;
      }
      let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
      if (resultado != digitos.charAt(0)) return false;
      tamanho = tamanho + 1;
      numeros = cnpj.substring(0, tamanho);
      soma = 0;
      pos = tamanho - 7;
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) pos = 9;
      }
      resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
      if (resultado != digitos.charAt(1)) return false;
      return true;
    },
    validateDoc: function() {
      let response = false;
      const doc = this.client.doc.replace(/\D+/g, "");
      if (this.client.doc.length == 14) {
        response = this.validCpf(doc);
      }
      if (this.client.doc.length >= 18) {
        response = this.validCnpj(doc);
        if (response) {
          this.getPjInfo(doc);
        }
      }
      this.validDoc = response;
    },
    getPjInfo: function(cnpj) {
      Axios.get("/api/v1/checkcnpj", {
        params: {
          cnpj
        }
      })
        .then((response) => {
          if (response.data.status == "success") {
            const info = response.data.info;
            this.client.razao = info.razao;
            this.client.fantasia = info.fantasia;
            this.client.address.cep = info.cep;
            this.client.address.street = info.street;
            this.client.address.number = info.street_number;
            this.client.address.complement = info.complement;
            this.client.address.neighborhood = info.neighborhood;
            this.client.address.city = info.city;
            this.client.address.state = info.state;
          } else {
            this.client.razao = "";
            this.client.fantasia = "";
            this.client.address.cep = "";
            this.client.address.street = "";
            this.client.address.number = "";
            this.client.address.complement = "";
            this.client.address.neighborhood = "";
            this.client.address.city = "";
            this.client.address.state = "";
          }
        })
        .catch(() => {
          //
        });
    },
    getAddress: function() {
      const cep = this.client.address.cep.replace("-", "");
      const address = {
        cep,
        street: "",
        complement: "",
        number: "",
        neighborhood: "",
        city: "",
        state: ""
      };
      Axios.get("/api/v1/checkcep", {
        params: {
          cep
        }
      })
        .then((response) => {
          if (response.data.status == "success") {
            const info = response.data.info;
            address.street = info.street;
            address.number = "";
            address.complement = info.complement;
            address.neighborhood = info.neighborhood;
            address.city = info.city;
            address.state = info.state;
          }
          const number = this.client.address.number;
          const complement = this.client.address.complement;
          this.client.address = address;
          this.client.address.number = number;
          this.client.address.complement = complement;
        })
        .catch(() => {
          //
        });
    },
    getClientDetails: function() {
      Axios.get("/api/v1/profile/client/details").then((response) => {
        this.client = response.data;
      });
    },
    updateClientDetails: function() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        Axios.put("/api/v1/profile/client/details", {
          data: this.client
        }).then((response) => {
          const data = response.data;
          if (data.status == "success") {
            this.getClientDetails();
          }
          this.updateStatus.message = data.msg;
          this.updateStatus.color =
            data.status == "success" ? "success" : "error";
          this.updateStatus.show = true;
          this.loading = false;
        });
      }
    }
  },
  mounted() {
    this.getClientDetails();
  }
};
</script>
<style>
.menuTitle {
  font-size: 20px;
  color: #132237;
  font-weight: 500;
  text-transform: uppercase;
  border-bottom: 3px #60ba8e45 solid;
}
.menuSubtitle {
  font-size: 14px;
  font-weight: 300;
  color: #000000ba;
}
</style>
